import React, { useRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { inWindow } from 'api';
const LxPopover = ({ top, left, right, bottom, resetStyle = {}, children, visible, setVisible, acceptTopBottom, offset = [], height = 0, container, }) => {
    const ref = useRef(null);
    const [leftCur, setLeftCur] = useState(0);
    const [topCur, setTopCur] = useState(0);
    const [offsetX = 0, offsetY = 0] = offset;
    const leftAfterOffset = left + +offsetX;
    const rightAfterOffset = top + +offsetY;
    const [mailAtResultPos, setMailAtResultPos] = useState('bottom');
    const [childrenWithProps, setChildrenWithProps] = useState('');
    useEffect(() => {
        if (ref.current) {
            const { clientWidth } = ref.current;
            let { clientHeight } = ref.current;
            if (height) {
                clientHeight = height;
            }
            setLeftCur(leftAfterOffset);
            setTopCur(rightAfterOffset);
            setMailAtResultPos('bottom');
            if (right && clientWidth > right) {
                setLeftCur(leftAfterOffset - clientWidth - 12);
            }
            if (bottom && clientHeight > bottom) {
                if (acceptTopBottom) {
                    setMailAtResultPos('top');
                    return;
                }
                let topPos = rightAfterOffset - clientHeight - offsetY;
                if (topPos < 20) {
                    topPos = 20;
                }
                setTopCur(topPos);
            }
        }
    }, [right, bottom, acceptTopBottom, offsetX, offsetY, leftAfterOffset, rightAfterOffset, height]);
    const delegateVisible = e => {
        var _a;
        if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            setVisible && setVisible(false);
        }
    };
    useEffect(() => {
        document.body.addEventListener('click', delegateVisible);
        return () => {
            document.body.removeEventListener('click', delegateVisible);
        };
    }, []);
    useEffect(() => {
        const childMap = React.Children.map(children, child => React.cloneElement(child, { resultPos: mailAtResultPos }));
        setChildrenWithProps(childMap);
    }, [children, mailAtResultPos]);
    const child = (React.createElement("div", { className: "lx-popover", style: Object.assign({ position: 'absolute', zIndex: '1051', background: '#FFFFFF', boxShadow: '0px 4px 8px rgb(38 42 51 / 20%)', borderRadius: '6px', top: topCur - 5, left: leftCur }, resetStyle), ref: ref, hidden: !visible }, childrenWithProps));
    if (!inWindow())
        return React.createElement(React.Fragment, null);
    return ReactDOM.createPortal(child, container || document.body);
};
export default LxPopover;
